import React, { useEffect } from 'react'
import classes from './MyStudentsFilters.module.css'
import { Grid, Text, Input, InputGroup, InputLeftAddon, GridItem, Button, useToast, Divider, Select, Tag, TagLabel, TagCloseButton, Flex } from '@chakra-ui/react'
import { SearchIcon } from '@chakra-ui/icons'
import { useStudentsFilters, useStudentsStore } from '../../store/studentsStore'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import StudentsService from '../../API/StudentsService'
import { useGlobalStore } from '../../store/globalStore'
import { toastError, toastSuccess, toastWarning, toISODate } from '../../utils/globalHelper'

function MyStudentsFilters() {
    const toast = useToast()
    const subjects = useGlobalStore(state => state.subjects)
    const [searchFilters, setSearchFilters] = useStudentsStore(state => [state.searchFilters, state.setSearchFilters])
    const [studentLoading, setStudentsLoading] = useStudentsStore(state => [state.studentsLoading, state.setStudentsLoading])
    const [studentsDumpLoading, setStudentsDumpLoading] = useStudentsStore(state => [state.studentsDumpLoading, state.setStudentsDumpLoading])
    const [filters, setFilters] = useStudentsFilters(state => [state.filters, state.setFilters])
    const setStudents = useStudentsStore(state => state.setStudents)
    const getStudents = useAccessAPI(StudentsService.getStudents)

    const onUpdateBtn = async () => {
        if (!filters?.potok12 && !filters?.potok3) {
            toast(toastWarning('Не выбран поток'))
            return
        }

        if (!filters?.month) {
            toast(toastWarning('Не выбран месяц'))
            return
        }

        setStudentsLoading(true)
        const response = await getStudents(filters)
        if (response?.status === 200) {
            if (response?.data?.length > 0)
                setStudents(response.data.map((stud) => {
                    return {...stud, birthday: stud.birthday === null ? '' : stud.birthday}
                }))
            else {
                setStudents([])
                toast(toastWarning('По заданным фильтрам не найдено учеников'))
            }
        } else {
            if (response?.status === 403)
                toast(toastError('Невозможно получить учеников для данного контекста'))
            else
                toast(toastError('Ошибка при обновлении учеников'))
        }
        setStudentsLoading(false)
    }

    useEffect(() => {
        if (filters?.month) {
            let startDate, endDate
            const monthDate = new Date(filters.month)
            if (filters?.filter_syscoursetype_ids?.length > 1) {
                startDate = filters?.potok12 ? new Date(monthDate.getFullYear(), monthDate.getMonth(), 1)
                                             : new Date(monthDate.getFullYear(), monthDate.getMonth(), 14)
                endDate = filters?.potok3 ? new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 1)
                                          : new Date(monthDate.getFullYear(), monthDate.getMonth(), 15)
            } else {
                startDate = filters?.potok12 ? new Date(monthDate.getFullYear(), 1, 1)
                                             : new Date(monthDate.getFullYear(), 3, 1)
                endDate = new Date(monthDate.getFullYear(), 6, 1)
            }

            setFilters({
                ...filters,
                filter_start_date: toISODate(startDate),
                filter_end_date: toISODate(endDate),
            })
        }
    }, [filters.month, filters.potok12, filters.potok3, filters.filter_syscoursetype_ids])

    return (
        <Grid className={classes.container}>
            <GridItem colSpan={2}>
                <Button
                    disabled={studentLoading}
                    loadingText="Обновление"
                    onClick={onUpdateBtn}
                >
                    Обновить
                </Button>
            </GridItem>
            <GridItem justifySelf='right' style={{zIndex: -100}}>
                <Button
                    isLoading={studentsDumpLoading}
                    loadingText="Выгрузка"
                >
                    Выгрузить
                </Button>
            </GridItem>

            <div/>
            <Button
                variant='outline'
                style={filters?.filter_syscoursetype_ids?.length > 1 ? { background: 'orange' } : {}}
                onClick={() => setFilters({...filters, filter_syscoursetype_ids: [22, 25, 27, 31]})}
            >
                Основной курс
            </Button>
            <Button
                variant='outline'
                style={filters?.filter_syscoursetype_ids?.length === 1 ? { background: 'orange' } : {}}
                onClick={() => setFilters({...filters, filter_syscoursetype_ids: [26]})}
            >
                Флеш
            </Button>

            <Input
                type='month'
                value={filters?.month ? filters.month.substring(0, 7) : ''}
                onChange={e => 
                    setFilters({...filters, month: e.target.value ? toISODate(new Date(e.target.value)) : null})
                }
            />
            <Button
                variant='outline'
                style={filters?.potok12 ? { background: 'orange' } : {}}
                onClick={() => setFilters({...filters, potok12: !filters?.potok12})}
            >
                Поток 1-2
            </Button>
            <Button
                variant='outline'
                style={filters?.potok3 ? { background: 'orange' } : {}}
                onClick={() => setFilters({...filters, potok3: !filters?.potok3})}
            >
                Поток 3
            </Button>

            <GridItem colSpan={3}>
                <Divider />
            </GridItem>
            <Text>Цели:</Text>
            <InputGroup>
                <InputLeftAddon>от</InputLeftAddon>
                <Input
                    placeholder='0'
                    type='number'
                    value={searchFilters.start_goal}
                    onChange={event => setSearchFilters({...searchFilters, start_goal: event.target.value})}
                />
            </InputGroup>
            <InputGroup>
                <InputLeftAddon>до</InputLeftAddon>
                <Input
                    placeholder='100'
                    type='number'
                    value={searchFilters.end_goal}
                    onChange={event => setSearchFilters({...searchFilters, end_goal: event.target.value})}
                />
            </InputGroup>
            <Text>Предмет:</Text>
            <GridItem colSpan={2}>
                <Select
                    isDisabled={searchFilters.subjects.length > 5}
                    placeholder='Добавьте фильтр предмета'
                    onChange={event => {
                        if (event.target.value) {
                            setSearchFilters({...searchFilters, subjects: [...searchFilters.subjects, event.target.value]})
                            event.target.value = ''
                        }
                    }}
                >
                    {subjects.map((subject) => (
                        !searchFilters.subjects.includes(subject.title) &&
                        <option value={subject.title} key={`subjfilter${subject.id}`}>
                            {subject.title}
                        </option>
                    ))}
                </Select>
            </GridItem>
            {
            searchFilters.subjects.length > 0 &&
            <GridItem colSpan={2} colStart={2}>
                <Flex flexWrap='wrap' gap='4px'>
                    {searchFilters.subjects.map((subject) => (
                        <Tag key={`subjtag${subject}`}>
                            <TagLabel>{subject}</TagLabel>
                            <TagCloseButton
                                onClick={() => setSearchFilters({...searchFilters, subjects: searchFilters.subjects.filter(s => s !== subject)})}
                            />
                        </Tag>
                    ))}
                </Flex>
            </GridItem>
            }
            <GridItem colSpan={3}>
                <InputGroup>
                    <InputLeftAddon><SearchIcon/></InputLeftAddon>
                    <Input
                        placeholder='Фильтр по имени или почте'
                        value={searchFilters.string}
                        onChange={event => setSearchFilters({...searchFilters, string: event.target.value})}
                    />
                </InputGroup>
            </GridItem>
        </Grid>
    )
}

export default MyStudentsFilters
